import { Box, Button, CircularProgress, MenuItem, Select, Typography } from '@mui/material';
import { TemplateSelectorProps } from './TemplateSelectorType';

function TemplateSelector<T>({
  templates,
  isLoading,
  error,
  selectedId,
  setSelectedId,
  isAssigning,
  assignTemplate,
  assignError,
  getName,
  placeholder = 'Wybierz szablon',
  buttonLabel = 'Załaduj szablon',
}: TemplateSelectorProps<T>) {
  if (isLoading) return <CircularProgress size={24} />;
  if (error) return <Typography color="error">Błąd ładowania szablonów</Typography>;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Select
        value={selectedId}
        onChange={(e) => setSelectedId(Number(e.target.value))}
        displayEmpty
        size="small"
        sx={{ minWidth: 220 }}
        disabled={isAssigning}
      >
        <MenuItem value="">{placeholder}</MenuItem>
        {templates?.map((template: any) => (
          <MenuItem key={template.id} value={template.id}>
            {getName(template)}
          </MenuItem>
        ))}
      </Select>
      <Button variant="outlined" onClick={assignTemplate} disabled={!selectedId || isAssigning}>
        {buttonLabel}
      </Button>
      {assignError && (
        <Typography color="error" variant="body2" sx={{ ml: 2 }}>
          Błąd przypisania szablonu
        </Typography>
      )}
    </Box>
  );
}

export default TemplateSelector;
